import React, { useState, useCallback } from 'react'

import { Button, TagComponent } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { number, oneOfType, string } from 'prop-types'

import AppealModal from './AppealModal'

const TRANSLATION_PREFIX = 'profile.my_products.suspension_appeal'

function SuspensionAppeal({ itemId, suspensionReason, appealStatus = null }) {
  const [status, setStatus] = useState(appealStatus)
  const [modalIsOpen, setModalIsOpen] = useState(false)

  const openModal = useCallback(() => setModalIsOpen(true), [])
  const closeModal = useCallback(() => setModalIsOpen(false), [])

  const handleSubmitted = useCallback((newStatus) => {
    setStatus(newStatus)
    setModalIsOpen(false)
  }, [])

  const reasonLabel = I18n.t(`${TRANSLATION_PREFIX}.reasons.${suspensionReason}`)

  const renderAction = () => {
    if (!status) {
      return (
        <Button size="small" type="secondary" onClick={openModal}>
          {I18n.t(`${TRANSLATION_PREFIX}.appeal`)}
        </Button>
      )
    }

    if (status === 'pending') {
      return <TagComponent color="attention">{I18n.t(`${TRANSLATION_PREFIX}.pending`)}</TagComponent>
    }

    if (status === 'accepted') {
      return <TagComponent color="primary">{I18n.t(`${TRANSLATION_PREFIX}.accepted`)}</TagComponent>
    }

    return <TagComponent>{I18n.t(`${TRANSLATION_PREFIX}.rejected`)}</TagComponent>
  }

  return (
    <div className="suspension-appeal">
      <span className="suspension-appeal__reason">{reasonLabel}</span>
      {renderAction()}
      {modalIsOpen && (
        <AppealModal
          itemId={itemId}
          reasonLabel={reasonLabel}
          onClose={closeModal}
          onSubmitted={handleSubmitted}
        />
      )}
    </div>
  )
}

SuspensionAppeal.propTypes = {
  itemId: oneOfType([number, string]).isRequired,
  suspensionReason: string.isRequired,
  appealStatus: string,
}

export default SuspensionAppeal
